package org.vreo.devicehub.features.device.presentation.registerDevice

import org.vreo.devicehub.features.core.presentation.UiText
import org.vreo.devicehub.features.core.domain.device.device.AnprDevice

/**
 * Register device state
 */
data class RegisterDeviceState(
    val isLoading: Boolean = false,
    val error: UiText? = null,

    val autoGenerateSerialNumber: Boolean = true,
    val invalidSerialNumber: Boolean = false,
    val selectedProductIndex: Int = 0,
    val serialNumber: String = "",

    val deviceConnected: Boolean = false,
    val deviceIpAddress: String = "",
    val device: AnprDevice? = null
)